// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__1mngL"};